import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { TIEULUANTONGQUAN_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import moment from 'moment';
import { trangThaiTieuLuanTongQuanValue } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';

const schema = yup.object().shape({
    tenTieuLuan: yup.string().required('Vui lòng nhập tên tiểu luận')
});

const TieuLuanTongQuanEdit = ({ hoSoId, dataEdit, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        if (dataEdit) {
            setInitialValues({
                tenTieuLuan: dataEdit.tenTieuLuan || '',
                tuNgay: dataEdit.tuNgay ? moment(dataEdit.tuNgay).format('YYYY-MM-DD') : '',
                denNgay: dataEdit.denNgay ? moment(dataEdit.denNgay).format('YYYY-MM-DD') : '',
                fileBanHanh: dataEdit.fileBanHanh || ''
            });
        }
    }, [dataEdit]);

    const editFunc = useMutation((value) => Put(`${TIEULUANTONGQUAN_API.UPDATE_ITEM}/${dataEdit.id}`, null, value, false));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            HoSoNghienCuuSinhId: hoSoId,
            TenTieuLuan: values.tenTieuLuan || '',
            TuNgay: values.tuNgay || null,
            DenNgay: values.denNgay || null,
            TrangThai: dataEdit.trangThai || trangThaiTieuLuanTongQuanValue.chuaThucHien,
            FileBanHanh: values.fileBanHanh
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['tieuLuanTongQuanData', hoSoId]);
                    queryClient.invalidateQueries(['duyetTieuLuanTongQuanData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    if (!initialValues) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Cập nhật Tiểu luận tổng quan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={initialValues}
                    enableReinitialize
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên tiểu luận <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenTieuLuan"
                                            value={values.tenTieuLuan}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.tenTieuLuan && !!errors.tenTieuLuan && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenTieuLuan}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Từ ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="tuNgay"
                                            value={values.tuNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đến ngày</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="denNgay"
                                            value={values.denNgay}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File ký ban hành quyết định"
                                            value={values.fileBanHanh}
                                            onChangeProp={(url) => setFieldValue('fileBanHanh', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-right mt-3">
                                <Button variant="secondary" className="mr-2" onClick={() => setViewMode('list')} disabled={isSubmitting}>
                                    Hủy
                                </Button>
                                <Button variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Đang lưu...' : 'Cập nhật'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default TieuLuanTongQuanEdit;
